<template>

  <div class="py-4 container-fluid production-create-page">
    <div class="row production-top-row">

      <div class="col-md-8 d-flex">
        <div ref="productionFormCard" class="card mb-2 w-100 d-flex flex-column production-form-card">
          <div class="card-header pb-0 flex-shrink-0">
            <div class="d-flex align-items-center">
              <span class="section-title">CREAR PRODUCCION DE MODELO</span>
            </div>
          </div>
          <div class="card-body production-form-card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="amount" class="form-label">Modelo</label>
                  <select ref="modelSelect" id="models" class="form-select select2" style="width:100%;" :disabled="isProductionFinished">
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Consec. Producción</label>
                <argon-input type="text" v-model="form.consecutivo" :disabled="isProductionFinished" />
              </div>
              <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Consec. Extrusión</label>
                <argon-input type="text" v-model="form.consecutivo_extruccion" :disabled="isProductionFinished" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="form.description" :disabled="isProductionFinished" />
              </div>

              

              <!--  
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Consecutivo Secado</label>
                <argon-input type="text" v-model="form.consecutivo_secado" />
              </div>
              -->

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha de entrega</label>
                <argon-input type="date" v-model="form.delivery_date" :disabled="isProductionFinished" />
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status" @change="handleStatusChange" :disabled="form.status == 2" >
                  <option value="0">Pendiente</option>
                 <!--  <option value="1">Activo</option> -->
                  <option value="2">Terminado</option>
                </select>
              </div>
            </div>
            <div class="text-end mt-3">
              <argon-button color="warning" size="sm" @click="save" v-if="form.status < 2">Guardar</argon-button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex costos-adicionales-col" v-if="form.id != 0">
        <div ref="costosAdicionalesCard" class="card mb-2 w-100 d-flex flex-column costos-adicionales-card" :style="costosAdicionalesHeight != null ? { height: costosAdicionalesHeight + 'px' } : {}">
          <div class="card-header flex-shrink-0">
            <div class="d-flex align-items-center">
              <span class="section-title">COSTOS ADICIONALES</span>

              <argon-button color="warning" size="sm" class="ms-auto" @click="openModalNovelty"
                v-if="form.status < 2">Agregar</argon-button>
            </div>

          </div>
          <div class="card-body pt-0 flex-grow-1 costos-adicionales-card-body">

            <div class="p-0 costos-adicionales-table-wrap">
              <table class="table align-items-center mb-0 table-layout-fixed">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 costos-adicionales-th-detalle">Detalle</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center costos-adicionales-th-total">Total</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center costos-adicionales-th-opciones">Opciones</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="value in novelties.data" :key="value.id">
                    <td class="costos-adicionales-detalle-cell">
                      <a @click="viewObservation(value.observation)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer costos-adicionales-detalle-link"
                        :title="value.observation || 'Sin detalle'">
                        {{ truncateObservation(value.observation) }}
                      </a>
                    </td>
                    <td class="text-center">
                      <h6 class="mb-0 text-sm">{{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      }) }}</h6>
                    </td>

                    <td class="text-center">
                      <a @click="editRegisterNovelty(value)" v-if="!isProductionFinished"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Eliminar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <a @click="deleteRegisterNovelty(value.id)" v-if="!isProductionFinished"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Tarjeta de defecto -->
        <!--  v-if="form.status != 0" -->
        <div class="card mb-2" hidden>
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="section-title">REGISTRO DEFECTUOSOS</span>

              <!-- <argon-button color="success" size="sm" class="ms-auto" @click="openModalDefects">Agregar</argon-button> -->
            </div>

          </div>
          <div class="card-body pt-0">

            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Total
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="value in novelties.data" :key="value.id">
                    <td
                      style="width: 70%; word-wrap: break-word; white-space: normal; vertical-align: top; text-align: left;">
                      <a @click="viewObservation(value.observation)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer d-block text-truncate"
                        style="max-width: 100%;"
                        :title="value.observation || 'Sin detalle'">
                        {{ truncateObservation(value.observation) }}
                      </a>
                    </td>
                    <td class="text-center">
                      <h6 class="mb-0 text-sm">{{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      }) }}</h6>
                    </td>

                    <td class="text-center">
                      <a @click="editRegisterDefects(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Eliminar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <a @click="deleteRegisterDefects(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-3" v-show="form.id != 0">


        <!-- Item 1 -->
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">

            <span class="section-title">EXTRUSIÓN</span>
            <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(0)">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </button>
          </div>
          <div class="collapse" ref="collapse0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="maquina" class="form-label">Máquina</label>
                    <select id="maquina" class="form-select" v-model="extrusion.machine" @change="saveExtruction" :disabled="isProductionFinished">
                      <option value="">Seleccionar máquina</option>
                      <option value="SOUZA">SOUZA</option>
                      <option value="VERDES">VERDES</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="tipo_boquilla" class="form-label">Tipo de Boquilla</label>
                    <select id="tipo_boquilla" class="form-select" v-model="extrusion.nozzle_type" @change="saveExtruction" :disabled="isProductionFinished">
                      <option value="">Seleccionar tipo</option>
                      <option value="1">Tipo 1</option>
                      <option value="2">Tipo 2</option>
                      <option value="3">Tipo 3</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="tiempo_programado" class="form-control-label">Tiempo Programado (horas)</label>
                    <input type="number" class="form-control" id="tiempo_programado" step="0.01" min="0" max="9.99"
                      v-model.number="extrusion.scheduled_time" @blur="saveExtruction" :disabled="isProductionFinished">
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="tiempo_perdido" class="form-control-label">Tiempo Perdido (horas)</label>
                    <div class="input-group">
                      <input type="text" class="form-control" id="tiempo_perdido" step="0.01" min="0" max="9.99"
                        v-model.number="extrusion.lost_time" readonly />
                      <span class="input-group-text text-body"
                        style="border-left: 0px !important;border-right: 1px solid #d2d6da;"
                        @click="openModalLostTimes()" :class="{ 'disabled': isProductionFinished }" v-if="!isProductionFinished">
                        <i class="fas fa-plus" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>


                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="tiempo_efectivo" class="form-control-label">Tiempo Efectivo</label>
                    <input type="number" class="form-control" id="tiempo_efectivo" step="0.01"
                      :value="extrusion.effective_time != null ? Number(extrusion.effective_time).toFixed(2) : ''" readonly>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="cantidad" class="form-control-label">Numero alistamientos</label>
                    <input type="number" class="form-control" id="cantidad" step="0.01" min="0"
                      v-model.number="extrusion.setup_count" @blur="saveExtruction" :disabled="isProductionFinished">
                  </div>
                </div>


                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="numero_cortes" class="form-control-label">Número de Cortes</label>
                    <input type="number" class="form-control" id="numero_cortes" step="0.01" min="0"
                      v-model.number="extrusion.cut_count"
                      @input="calcularTiempoEfectivo" @blur="saveExtruction" :disabled="isProductionFinished">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="unidades_corte" class="form-control-label">Unidades por Corte</label>
                    <input type="number" class="form-control" id="unidades_corte" step="0.01" min="0"
                      v-model.number="extrusion.units_per_cut"
                      @input="calcularTiempoEfectivo" @blur="saveExtruction" :disabled="isProductionFinished">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="cantidad" class="form-control-label">Cantidad
                      (
                      {{
                        extrusion.quantity > 0
                          ? (((extrusion.quantity - extrusion.extrusion_quantity) * 100) / extrusion.quantity).toFixed(2)
                          : 0
                      }}% Repr.
                      )
                    </label>
                    <input type="number" class="form-control" id="cantidad" step="0.01" :value="extrusion.quantity != null ? Number(extrusion.quantity).toFixed(2) : ''" readonly>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="cantidad" class="form-control-label">Cant. de extrusion
                    </label>
                    <input type="number" class="form-control" id="cantidad" step="0.01" :value="extrusion.extrusion_quantity != null ? Number(extrusion.extrusion_quantity).toFixed(2) : ''" readonly>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="peso_extruido" class="form-control-label">Peso unitario extruido(Kilogramo)</label>
                    <input type="number" class="form-control" id="peso_extruido" step="0.01" min="0"
                      v-model.number="extrusion.extruded_weight" @blur="saveExtruction" :disabled="isProductionFinished">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="peso_seco" class="form-control-label">Peso Seco (Kilogramo)</label>
                    <input type="number" class="form-control" id="peso_seco" step="0.01" :value="extrusion.dry_weight != null ? Number(extrusion.dry_weight).toFixed(2) : ''" readonly>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="consumo_arcilla" class="form-control-label">Consumo de Arcilla (Kilogramo)</label>
                    <input type="number" class="form-control" id="consumo_arcilla" step="0.01"
                      :value="extrusion.clay_consumption != null ? Number(extrusion.clay_consumption).toFixed(2) : ''" readonly>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="total_consumo" class="form-control-label">Total Consumo (Kilogramo)</label>
                    <input type="number" class="form-control" id="total_consumo" step="0.01"
                      :value="extrusion.total_consumption != null ? Number(extrusion.total_consumption).toFixed(2) : ''" readonly>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="total_consumo" class="form-control-label">Promedio hora (Ton)</label>
                    <input type="number" class="form-control" id="total_consumo"
                      :value="extrusion.effective_time > 0 ? (extrusion.clay_consumption / extrusion.effective_time).toFixed(2) : 0"
                      readonly>
                  </div>
                </div>

                <!-- 
                <div class="col-md-12 text-end" v-if="form.status < 2">
                  <argon-button color="success" size="sm" @click="saveExtruction">Guardar</argon-button>
                </div>
                -->

              </div>




            </div>
          </div>
        </div>

        <!-- Item 2 -->
        <div class="card mt-2 assigned-users-card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span class="section-title">SECADO</span>
            <div class="d-flex align-items-center" style="gap: 10px;">
              <argon-button color="warning" size="sm" v-if="collapseOpen[1] && form.status < 2"
                @click="openModalDrying()">
                Agregar secado
              </argon-button>
              <button
                v-if="dryings.length > 0"
                type="button"
                class="btn btn-outline-secondary btn-sm m-0"
                :disabled="syncingDrying"
                @click="syncKardexDrying"
              >
                {{ syncingDrying ? '…' : 'Sincronizar' }}
              </button>
              <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(1)">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="collapse" ref="collapse1">
            <div class="card-body">

              <div class="mb-2">

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Opciones
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Modulo</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                            Cantidad
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                            Fecha de
                            inicio
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha estimada</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha de entrega</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="value in dryings" :key="value.id">

                          <td class="align-middle text-center">

                            <a @click="checkDeliveredDrying(value)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                              data-original-title="Eliminar registro" v-if="value.delivered_at == null && !isProductionFinished">
                              <i class="fa fa-check"></i>
                            </a>

                            <span style="color: forestgreen;" v-if="value.delivered_at != null">
                              <i class="fa fa-check"></i>
                            </span>




                            <a @click="deleteDryings(value.id)" v-if="value.delivered_at == null && !isProductionFinished"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                              data-toggle="tooltip" data-original-title="Eliminar registro">
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.bodega?.name || "No encontrado" }}</h6>
                                <p class="text-xs text-secondary mb-0">Secado: {{ value?.type === 1 ? "Natural" :
                                  value?.type === 2 ? "Artificial" : "No definido" }}</p>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle">
                            <div class="text-secondary text-xs font-weight-bold text-center">
                              {{ value?.quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.started_at) ? new
                                Date(value.started_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.assigned_at) ? new
                                Date(value.assigned_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.delivered_at) ? new
                                Date(value.delivered_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>




                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        <!-- Item 1 -->
        <div class="card mt-2">
          <div class="card-header d-flex justify-content-between align-items-center">

            <span class="section-title">USUARIOS ASIGNADOS</span>

            <div class="d-flex align-items-center" style="gap: 10px;">
              
              <argon-button
                v-if="collapseOpen[4] && hasAssignedUsers && selectedAssignedUserRows.length > 0 && selectedBaseAction === 'receive'"
                color="info"
                size="sm"
                :disabled="isProductionFinished"
                @click="markSelectedReceived"
              >
                Inicio
              </argon-button>
              <argon-button
                v-if="collapseOpen[4] && hasAssignedUsers && selectedAssignedUserRows.length > 0 && selectedBaseAction === 'deliver'"
                color="primary"
                size="sm"
                :disabled="isProductionFinished"
                @click="markSelectedDelivered"
              >
                Entregado
              </argon-button>
              <argon-button
                v-if="collapseOpen[4] && hasAssignedUsers && selectedAssignedUserRows.length > 0 && selectedBaseAction === 'validate'"
                color="success"
                size="sm"
                :disabled="isProductionFinished"
                @click="markSelectedValidated"
              >
                Validar
              </argon-button>
              <argon-button
                color="warning"
                size="sm"
                v-if="collapseOpen[4] && form.status < 2"
                :disabled="isProductionFinished"
                @click="openModal(1)"
              >
                Asignar usuarios
              </argon-button>
              <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(4)">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="collapse" ref="collapse4">
            <div class="card-body">

            <div class="mb-2" v-if="form.id != 0">
              <div class="row">

                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Opciones</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cuadrilla
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio
                        </th>

                        <!-- <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              recibida</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              entregada</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              defectuosa</th> -->
                        <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha de asignación</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha estimada entrega</th> -->
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Fecha Inicio</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Fecha Termino</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Fecha validado</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          observación</th>
                        <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Total
                              ganancia</th> -->

                      </tr>
                    </thead>
                    <tbody v-if="data && data.data">
                      <tr v-for="value in data.data.filter(v => v.modulo === 1 || v.modulo === 2)" :key="value.id">
                        <td class="align-middle text-center">
                          <div
                            style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                            
                            <div class="custom-checkbox-wrapper-assigned" v-if="value.validated_date == null">
                              <input
                                type="checkbox"
                                class="custom-checkbox"
                                :id="'checkbox-' + value.id"
                                :value="value.id"
                                v-model="selectedProductionUserIds"
                                :disabled="isAssignedUserCheckboxDisabled(value)"
                              />
                              <label :for="'checkbox-' + value.id" class="custom-checkbox-label">
                                <i class="fa fa-check"></i>
                              </label>
                            </div>

                            <span class="assigned-user-check" style="color: forestgreen;" v-if="value.validated_date != null">
                              <i class="fa fa-check"></i>
                            </span>

                            <a @click="deleteUserRegister(value.id)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                              data-original-title="Eliminar registro" v-if="value.received_date == null && !isProductionFinished">
                              <i class="fa fa-trash"></i>
                            </a>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex px-2 py-1">
                            <div class="d-flex flex-column justify-content-center">
                              <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                            </div>
                          </div>
                        </td>

                        <td class="align-middle">
                          <div class="text-secondary text-xs font-weight-bold text-center">
                            {{ value?.cuadrilla_name ?? value?.user?.cuadrilla_name ?? 'Sin asignar' }}
                          </div>
                        </td>
                        <td class="align-middle">
                          <div class="text-secondary text-xs font-weight-bold text-center">
                            {{ value?.oficio?.name }}
                          </div>
                        </td>

                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.received_date) ? new
                              Date(value.received_date).toLocaleString('es-ES', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                              }) : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.delivered_date) ? new
                              Date(value.delivered_date).toLocaleString('es-ES', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                              }) : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.validated_date) ? new
                              Date(value.validated_date).toLocaleString('es-ES', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                              }) : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle" style="max-width: 200px;">
                          <a @click="viewObservation(value.observation)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer d-block text-truncate"
                            style="max-width: 100%;"
                            :title="value.observation || 'Sin detalle'">
                            {{ truncateObservation(value.observation) }}
                          </a>
                        </td>


                      </tr>


                    </tbody>
                  </table>
                </div>
              </div>
            </div>



            </div>
          </div>
        </div>



      </div>


    </div>





    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalUsers" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <span class="section-title" id="exampleModalLabel">Asignar Usuarios</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form class="row">

              <div class="col-6 mb-3">
                <label for="amount" class="form-control-label">Oficio</label>
                <select ref="processesSelect" id="oficio" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="col-6 mb-3">
                <label for="example-text-input" class="form-control-label">Cuadrilla</label>
                <select ref="cuadrillaSelect" id="cuadrilla" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="col-12 mb-3" v-if="production_user.oficio_id">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-control-label mb-0">Buscar usuario</label>
                  <button type="button" class="btn btn-link p-0 text-secondary" @click="toggleUserSearch"
                    :aria-label="showUserSearch ? 'Ocultar buscador de usuarios' : 'Mostrar buscador de usuarios'">
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </button>
                </div>
                <div v-if="showUserSearch" class="mt-2">
                  <input id="user-search" type="text" class="form-control" v-model.trim="userSearch"
                    placeholder="Escribe un nombre para filtrar..." autocomplete="off">
                </div>
              </div>

              <div class="col-12 mb-3" v-if="production_user.oficio_id && visibleUsers.length > 0">
                <label for="users-checkbox-list" class="form-label">Usuarios</label>
                <div id="users-checkbox-list" class="checkbox-grid">
                  <div v-for="user in visibleUsers" :key="user.id">
                    <argon-checkbox :id="'user-' + user.id" :value="user.id" v-model="production_user.user_id"
                      :checked="production_user.user_id.includes(user.id)">
                      {{ user.name }} - (Cuadrilla: {{ user.cuadrilla_name ?? "Sin asignar" }})
                    </argon-checkbox>

                  </div>
                </div>
              </div>

              <div class="col-12 mb-3" v-else-if="production_user.oficio_id && filteredUsers.length === 0">
                <p class="text-sm text-secondary mb-0 px-2">
                  {{ production_user.cuadrilla ? 'No hay usuarios para el oficio y la cuadrilla seleccionada.' : 'No hay usuarios para el oficio seleccionado.' }}
                </p>
              </div>

              <div class="col-12 mb-3"
                v-else-if="production_user.oficio_id && filteredUsers.length > 0 && visibleUsers.length === 0">
                <p class="text-sm text-secondary mb-0 px-2">
                  No hay usuarios que coincidan con la búsqueda.
                </p>
              </div>

            </form>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal secado  -->
    <div class="modal fade" id="ModalDrying" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <span class="section-title" id="exampleModalLabel">Agregar registro de secado</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <div class="row">

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="horno_id" class="form-control-label select2">Modulo</label>
                  <select ref="modelSelectHorno" id="horno_id" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="cantidad_secado" class="form-control-label">Cantidad</label>
                  <input type="number" class="form-control" id="cantidad_secado" v-model="drying.quantity">
                </div>
              </div>

              <!-- Radio Buttons -->
              <!-- <div class="mt-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="1" v-model="drying.type">
                  <label class="form-check-label" for="delivery_complete">
                    Secado Natural
                  </label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" value="2" v-model="drying.type">
                  <label class="form-check-label" for="delivery_partial">
                    Secado Artificial
                  </label>
                </div>
              </div> -->


              <div class="col-md-6">
                <div class="mb-3">
                  <label for="cantidad_averia" class="form-control-label">Fecha inicio</label>
                  <input type="date" class="form-control" id="cantidad_averia" v-model="drying.started_at">
                </div>
              </div>


              <div class="col-md-6">
                <div class="mb-3">
                  <label for="cantidad_averia_secado" class="form-control-label">Fecha estimada finalización</label>
                  <input type="date" class="form-control" id="cantidad_averia_secado" v-model="drying.assigned_at">
                </div>
              </div>
              <!--   <div class="col-md-4">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Fecha de entrega</label>
                  <input type="date" class="form-control" id="cantidad_averia_cargue" v-model="drying.delivered_at">
                </div>
              </div>
 -->
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalDrying">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveDrying">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    

    <!-- Modal Asignar costo adicional -->
    <div class="modal fade" id="ModalNovelty" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <span class="section-title" id="exampleModalLabel">Agregar costo adicional</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-control-label">Valor</label>
                <input type="text" v-model="formattedTotalNovelty" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="novelty.observation" />
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalNovelty">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormNovelty">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal tiempo perdido  -->
    <div class="modal fade" id="ModalLostTimes" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <span class="section-title" id="exampleModalLabel">Agregar Tiempos perdidos (minutos)</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row" v-for="value in categories" :key="value.id">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">{{ value.name }}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <input type="number" class="form-control" v-model.number="value.inputValue" step="0.01" min="0"
                    max="9.99" @blur="addLostTimeDetail(value.id, value.inputValue)" placeholder="Ingrese valor">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalLostTimes">Cerrar</button>
          </div>
        </div>
      </div>
    </div>



  </div>


  <!-- Estructura obligatoria del Toast de Bootstrap -->
  <div class="toast-container position-fixed top-0 end-0 p-3">
    <div ref="myToast" class="toast align-items-center bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body text-white">
          Cambios guardados
        </div>
        <button type="button" class="btn-close text-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    </div>
  </div>

</template>



<script>


import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal, Collapse } from 'bootstrap';
//import { Toast } from 'bootstrap';

//import * as bootstrap from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  setup() {
    const route = useRoute();
  

    return { route  };
  },
  data() {
    return {
      myToast : null,
      bsCollapse: [null, null, null, null, null],
      collapseOpen: [false, false, false, false, false],
      showMenu: false,
      ModalUsers: null,
      ModalDrying: null,
      ModalLostTimes: null,
      modalNovelty: null,
      modalDefects: null,
      modalModel: null,
      oficio_id: null,
      processes: [],
      cuadrillas: [],
      form: {
        id: 0,
        model_id: '',
        consecutivo: '',
        consecutivo_extruccion: '',
        consecutivo_secado: '',
        description: '',
        status: 0,
        delivery_date: '',
        price: 0,
        sync_secado: 0,
      },
      extrusion: {
        id: 0,
        production_id: 0,
        machine: '',
        setup_count: 0,
        nozzle_type: '',
        scheduled_time: 0,
        lost_time: 0,
        lost_time_details: [],
        effective_time: 0,
        setup_number: 0,
        cut_count: 0,
        units_per_cut: 0,
        quantity: 0,
        extrusion_quantity: 0,
        extruded_weight: 0,
        dry_weight: 0,
        clay_consumption: 0,
        total_consumption: 0
      },
      drying: {
        id: 0,
        production_id: 0,
        oven_id: '',
        type: 0,
        quantity: 0,
        warehouse_id: '',
        started_at: '',
        assigned_at: '',
        delivered_at: '',
        total_quantity: 0
      },
      dryings: [],
      syncingDrying: false,
      loadings: [],
      collapseInstances: {},
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      selectedProductionUserIds: [],
      filteredUsers: [],
      userSearch: '',
      showUserSearch: false,
      bodegas: [],
      categories: [],
      models: [],
      insumos: [],
      insumosInventory: [],
      sizes: [],
      users: [],
      colors: [],
      purchases: [],
      purchase: {
        id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        total_price: 0,
        supplier_name: ''
      },
      production_user: {
        id: 0,
        user_id: [],
        production_models_id: 0,
        oficio_id: 0,
        production_id: 0,
        modulo: 0,
        received_quantity: 0,
        delivered_quantity: 0,
        price: 0,
        assigned_at: '',
        estimated_at: '',
        cuadrilla: ''
      },
      production_model: {
        id: 0,
        production_id: 0,
        model_id: 0,
        size_id: 0,
        bodega_id: '',
        quantity_to_produce: 0,
        price: 0,
      },
      data: {},
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      novelty: {
        id: 0,
        production_id: 0,
        total: 0,
        observation: ''
      },
      fieldPayment: false,
      modalEvidencia: [],
      novelties: [],
      maxDryingQuantity: 0,
      costosAdicionalesHeight: null,
      costosAdicionalesResizeObserver: null
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton, ArgonCheckbox },
  computed: {
    isProductionFinished() {
      return this.form.status == 2;
    },
    assignedUserRows() {
      return (this.data?.data || []).filter((v) => v.modulo === 1 || v.modulo === 2);
    },
    hasAssignedUsers() {
      return this.assignedUserRows.length > 0;
    },
    selectedAssignedUserRows() {
      const selectedSet = new Set((this.selectedProductionUserIds || []).map(Number));
      return this.assignedUserRows.filter((r) => selectedSet.has(Number(r.id)));
    },
    selectedBaseAction() {
      const first = this.selectedAssignedUserRows?.[0];
      if (!first) return null;
      return this.getAssignedUserNextAction(first);
    },
    formattedTotalNovelty: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.novelty.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.novelty.total = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedPrice: {
      get() {
        return this.production_model.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.production_model.price = Math.floor(value.replace(/\./g, "") || 0);
      },
    },
    totalPrice() {
      // Calcula el total y aplica el formateo
      const total = this.production_model.quantity_to_produce * this.production_model.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    visibleUsers() {
      const query = this.normalizeText(this.userSearch);
      if (!query) return this.filteredUsers;

      return (this.filteredUsers || []).filter((user) => {
        const name = this.normalizeText(user?.name);
        return name.includes(query);
      });
    },


  },
  watch: {
    'form.id': function () {
      if (this.form.id != 0) this.$nextTick(() => this.syncCostosAdicionalesHeight());
    },
    'extrusion.scheduled_time': function () {
      this.calcularTiempoEfectivo();
    },
    'extrusion.lost_time': function () {
      this.calcularTiempoEfectivo();
    },
    'extrusion.cut_count': function () {
      this.calcularCantidad();
    },
    'extrusion.units_per_cut': function () {
      this.calcularCantidad();
    },
    'extrusion.extruded_weight': function () {
      this.extrusion.dry_weight = this.roundToTwoDecimals(this.extrusion.extruded_weight * 0.845);
    },
    'extrusion.dry_weight': function () {
      this.calcularConsumo();
    },
    'drying.quantity': function () {
      const totalQuantity = this.extrusion.quantity - this.extrusion.extrusion_quantity;

      console.log(this.extrusion);

      if (this.drying.quantity > totalQuantity) {
        this.drying.quantity = totalQuantity;
      }
      this.drying.total_quantity = Number(this.drying.quantity)
    },
    'drying.type': function () {
      this.calculateAssignedDate();
    },





    'form.bodega_id': function () {
      this.handleBodegaChange();
    },

  },
  methods: {
    getAssignedUserNextAction(value) {
      // Orden esperado: Inicio -> Entregado -> Validar
      if (value?.validated_date != null) return 'done';
      if (value?.received_date == null) return 'receive';
      if (value?.delivered_date == null) return 'deliver';
      if (value?.delivered_date != null && value?.validated_date == null) return 'validate';
      return null;
    },
    isAssignedUserCheckboxDisabled(value) {
      if (this.isProductionFinished) return true;
      if (value?.validated_date != null) return true;

      // Si ya está seleccionado, permitir deseleccionar
      const selectedSet = new Set((this.selectedProductionUserIds || []).map(Number));
      const isSelected = selectedSet.has(Number(value?.id));
      if (isSelected) return false;

      // Si no hay selección, permitir seleccionar cualquiera (pendiente)
      if (!this.selectedBaseAction) return false;

      // Solo permitir seleccionar registros que tengan la misma acción pendiente
      const action = this.getAssignedUserNextAction(value);
      return action !== this.selectedBaseAction;
    },
    toggleUserSearch() {
      this.showUserSearch = !this.showUserSearch;
      if (!this.showUserSearch) {
        this.userSearch = '';
      }
    },
    normalizeText(value) {
      return (value ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },
    async deleteDryings(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionDrying/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            
           
            await this.getDrying();
            this.calculateTotalDrying();
             this.calcularTiempoEfectivo();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    calculateAssignedDate() {
      //if (!this.drying.started_at || !this.drying.type) return;

      const startDate = new Date(this.drying.started_at);
      let daysToAdd = 0;

      if (this.drying.type == 1) {
        daysToAdd = 5;
      } else if (this.drying.type == 2) {
        daysToAdd = 1;
      }

      startDate.setDate(startDate.getDate() + daysToAdd);

      console.log(1);

      this.drying.assigned_at = startDate.toISOString().split('T')[0];
    },

    calculateTotalDrying() {
      // Suma todos los valores de lost_time_details
      const total = this.dryings.reduce((total, item) => {
        return total + (Number(item.quantity) || 0);
      }, 0);

      // Asigna el total a lost_time
      this.extrusion.extrusion_quantity = total;
    },
    calculateLostTimes() {
      // Suma todos los valores de lost_time_details
      const totalDetails = this.extrusion.lost_time_details.reduce((total, detail) => {
        return total + detail.value;
      }, 0);
      // Asigna el total a lost_time
      this.extrusion.lost_time = Number((totalDetails / 60).toFixed(2));
    },
    addLostTimeDetail(id, value) {
      const rounded = this.roundToTwoDecimals(value);
      const existingDetail = this.extrusion.lost_time_details.find(detail => detail.id === id);
      if (existingDetail) {
        existingDetail.value = rounded;
      } else {
        this.extrusion.lost_time_details.push({ id, value: rounded });
      }
      this.calculateLostTimes();
      this.saveExtruction();
    },
    calculateTotalQuantity() {
      const total = this.dryings.reduce((total, item) => {
        return total + (Number(item.quantity) || 0);
      }, 0);

      this.drying.quantity = this.extrusion.extrusion_quantity - total;
      this.maxDryingQuantity = this.drying.quantity;
    },
    toggleCollapse(index) {
      // Cierra todos
      this.bsCollapse.forEach((instance, i) => {
        if (instance && i !== index) instance.hide()
      })
      // Alterna el seleccionado
      const selected = this.bsCollapse[index]
      if (selected) selected.toggle()
    },
    roundToTwoDecimals(val) {
      if (val === null || val === undefined || val === '') return val;
      const num = Number(val);
      if (Number.isNaN(num)) return val;
      return Number(Number(num).toFixed(2));
    },
    limitExtrusionToTwoDecimals() {
      if (!this.extrusion) return;
      const r = this.roundToTwoDecimals.bind(this);
      this.extrusion.scheduled_time = r(this.extrusion.scheduled_time);
      this.extrusion.lost_time = r(this.extrusion.lost_time);
      this.extrusion.effective_time = r(this.extrusion.effective_time);
      this.extrusion.setup_count = r(this.extrusion.setup_count);
      this.extrusion.cut_count = r(this.extrusion.cut_count);
      this.extrusion.units_per_cut = r(this.extrusion.units_per_cut);
      this.extrusion.quantity = r(this.extrusion.quantity);
      this.extrusion.extrusion_quantity = r(this.extrusion.extrusion_quantity);
      this.extrusion.extruded_weight = r(this.extrusion.extruded_weight);
      this.extrusion.dry_weight = r(this.extrusion.dry_weight);
      this.extrusion.clay_consumption = r(this.extrusion.clay_consumption);
      this.extrusion.total_consumption = r(this.extrusion.total_consumption);
    },
    async saveExtruction() {
      if (this.isProductionFinished) {
        return;
      }
      this.limitExtrusionToTwoDecimals();
      console.log("Guardar Extrusion");
      try {

        console.log("Extrusión guardada",this.extrusion);
        const response = await this.$store.dispatch("productionExtrusion/save", this.extrusion);
        if (response && response.status >= 200 && response.status < 300) {

          console.log("Extrusión guardada");
          /* const toastEl = this.$refs.myToast
          const toast = new Toast(toastEl, { autohide: true, delay: 3000 })
          toast.show() */

          this.extrusion.id = response?.data?.id || 0;
          /* await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.extrusion.id = response?.data?.id || 0;
          }); */
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },

    async getCategory() {
      const categories = await this.$store.dispatch("categories/getCategories");
      this.categories = categories.data.map(category => ({
        ...category,
        inputValue: 0 
      }));
    },
    async getDrying() {
      this.dryings = await this.$store.dispatch("productionDrying/getData", this.form.id);
    },
    async syncKardexDrying() {
      if (!this.form?.id) return;
      this.syncingDrying = true;
      try {
        await this.$store.dispatch("productionDrying/syncKardex", this.form.id);
        await this.getDrying();
      } catch (error) {
        console.error("syncKardexDrying:", error);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.data?.message || error?.message || "No se pudo sincronizar el kardex de secado.",
        });
      } finally {
        this.syncingDrying = false;
      }
    },

    async saveDrying() {
      console.log("Guardar secado");

      if (this.drying.quantity <= 0) {
        await Swal.fire({
          icon: 'error',
          title: 'Error en la cantidad',
          text: 'La cantidad no puede ser cero o negativa',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6',
        });
        return; // Detiene la ejecución si la validación falla
      }

      try {
        const response = await this.$store.dispatch("productionDrying/save", this.drying);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(async () => {

            console.log('extrusion',response.data);

            //this.extrusion = response.data;
            await this.getDrying();
            this.closeModalDrying();
            this.calculateTotalDrying();
            this.calcularConsumo();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    initCollapses() {
      // Inicializar cada collapse individualmente
      const collapseElements = document.querySelectorAll('.collapse');
      collapseElements.forEach(el => {
        this.collapseInstances[el.id] = new Modal(el, {
          toggle: false
        });
      });
    },
    calcularTiempoEfectivo() {

      if (!this.extrusion) {
        console.error('extrusion no está definido');
        return;
      }

      // Asegúrate de que scheduled_time y lost_time sean números
      const scheduledTime = Number(this.extrusion.scheduled_time);
      const lostTime = Number(this.extrusion.lost_time);

      // Calcula el tiempo efectivo (siempre 2 decimales)
      this.extrusion.effective_time = this.roundToTwoDecimals(Math.max(0, scheduledTime - lostTime));
      this.saveExtruction();
    },
    calcularCantidad() {
      this.extrusion.quantity = this.roundToTwoDecimals(this.extrusion.cut_count * this.extrusion.units_per_cut);
    },
    calcularConsumo() {
      this.extrusion.clay_consumption = this.roundToTwoDecimals((this.extrusion.extrusion_quantity * this.extrusion.dry_weight) / 1000);
      this.extrusion.total_consumption = this.roundToTwoDecimals(this.extrusion.setup_count > 0
        ? (this.extrusion.clay_consumption * 1000) / this.extrusion.setup_count
        : 0);
      this.saveExtruction();
    },
    editModal(detail) {
      this.purchase = {
        id: detail.id,
        inventory_id: detail.inventory_id,
        quantity: detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_id).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    async submitEditForm() {
      try {
        const response = await this.$store.dispatch("productionDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeEditModal();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async onBodegaChange(data) {

      await this.$store.dispatch('productionModels/save', data);

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Bodega asignada',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

    },
    async handleStatusChange() {
      const statusStr = String(this.form.status);

      // Estado Terminado: validar acciones pendientes antes de permitir el cambio
      if (statusStr === '2') {
        const missing = this.getPendingActionsToFinishProduction();
        if (missing.length > 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede marcar como terminado',
            html: `
              <p>Faltan acciones por completar:</p>
              <ul style="text-align:left; margin: 0;">
                ${missing.map((m) => `<li>${m}</li>`).join('')}
              </ul>
            `,
            confirmButtonText: 'Entendido',
          });

          // Revertir a Pendiente automáticamente
          this.form.status = 0;
          await this.handleStatusChangeSave({ silent: true });
          return;
        }
      }

      // Estado Producción (legacy): confirmar por salida de insumos
      if (statusStr === '1') {
        const result = await Swal.fire({
          title: 'Confirmar cambio de estado',
          text: 'Al cambiar a estado producción, los insumos se restarán de las existencias. Verifica que tengas los insumos necesarios.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          await this.handleStatusChangeSave();
          await this.getInsumos();
        } else {
          this.form.status = 0;
        }
        return;
      }

      await this.handleStatusChangeSave();
    },
    getPendingActionsToFinishProduction() {
      const missing = [];

      // EXTRUSIÓN: al menos debe existir registro guardado
      if (!this.extrusion?.id) {
        missing.push('Extrusión: guardar la información de extrusión.');
      }

      // SECADO: debe haber al menos un registro y todos entregados
      const dryings = Array.isArray(this.dryings) ? this.dryings : [];
      if (dryings.length === 0) {
        missing.push('Secado: agregar al menos un registro de secado.');
      } else {
        const pendingDryings = dryings.filter((d) => d?.delivered_at == null);
        if (pendingDryings.length > 0) {
          missing.push(`Secado: entregar ${pendingDryings.length} registro(s).`);
        }
      }

      // USUARIOS ASIGNADOS: debe haber usuarios y todos deben estar validados
      const assigned = Array.isArray(this.data?.data)
        ? this.data.data.filter((v) => v?.modulo === 1 || v?.modulo === 2)
        : [];

      if (assigned.length === 0) {
        missing.push('Usuarios asignados: asignar al menos un usuario.');
      } else {
        let needStart = 0;
        let needDeliver = 0;
        let needValidate = 0;

        for (const r of assigned) {
          if (r?.validated_date != null) continue;

          if (r?.received_date == null) {
            needStart += 1;
            continue;
          }

          const deliveredQty = Number(r?.delivered_quantity || 0);
          const receivedQty = Number(r?.received_quantity || 0);
          if (r?.delivered_date == null || deliveredQty < receivedQty) {
            needDeliver += 1;
            continue;
          }

          if (r?.delivered_date != null && r?.validated_date == null && deliveredQty >= receivedQty) {
            needValidate += 1;
          }
        }

        if (needStart > 0) missing.push(`Usuarios asignados: falta Inicio en ${needStart} registro(s).`);
        if (needDeliver > 0) missing.push(`Usuarios asignados: falta Entregado en ${needDeliver} registro(s).`);
        if (needValidate > 0) missing.push(`Usuarios asignados: falta Validar en ${needValidate} registro(s).`);
      }

      return missing;
    },
    async handleStatusChangeSave({ silent = false } = {}) {
      const response = await this.$store.dispatch("production/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        if (!silent) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El estado cambio correctamente',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
        }
      } else {
        await Swal.fire({
          icon: 'error',
          title: '¡Ocurrio un error!',
          text: response.data.message || 'Error al guardar el registro',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });

        if (String(this.form.status) === '1') {
          this.form.status = 0;
        }


      }
    },
    async handleBodegaChange() {
      await this.$store.dispatch("production/save", this.form);
    },
    async getBodegas() {
      try {
        // Obtener las bodegas desde el store
        this.bodegas = await this.$store.dispatch('bodegas/getAll');

        // Obtener referencia al select
        const $selectModulo = $(this.$refs.modelSelectHorno);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModulo.data('select2')) {
          $selectModulo.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModulo.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 4).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModulo.append(option);
        });

        // Inicializar Select2
        $selectModulo.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalDrying .modal-body')
        }).on('change', () => {
           const selectedOption = $selectModulo.find(':selected');

           this.drying.warehouse_id = $selectModulo.val();

          const isArtificial = selectedOption.data('artificial') === 1;

          this.drying.type = isArtificial?2:1;
          
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.drying.warehouse_id) {
          $selectModulo.val(this.drying.warehouse_id).trigger('change');
        }

      } catch (error) {
        console.error('Error al obtener bodegas:', error);
      }
    },
    async getNovelties() {
      this.novelties = await this.$store.dispatch('productionNovelty/getData', this.form.id);
    },
    /** Cantidad por defecto para asignar al usuario según el módulo (1/2: extrusión/secado) */
    getDefaultReceivedQuantityForModule(modulo) {
      const mod = Number(modulo);
      // Módulo 1 (producción): usar cantidad total planificada del modelo
      if (mod === 1) {
        const qty = Number(this.production_model?.quantity_to_produce || 0);
        return isNaN(qty) ? 0 : qty;
      }
      // Módulo 2 (secado): usar cantidad total de extrusión (si existe)
      if (mod === 2) {
        const ext = this.extrusion || {};
        const qty = Number(ext.extrusion_quantity || ext.quantity || 0);
        return isNaN(qty) ? 0 : qty;
      }
      return 0;
    },
   async getOficios() {
    try {
      // Obtener los oficios desde el store
      this.processes = await this.$store.dispatch('users/getOficios');

      // Obtener referencia al select
      const $selectOficio = $(this.$refs.processesSelect);

      // Destruir la instancia previa de Select2 si existe
      if ($selectOficio.data('select2')) {
        $selectOficio.select2('destroy');
      }

      // Limpiar y agregar las opciones dinámicamente
      $selectOficio.empty().append('<option value="">Seleccione un oficio</option>');

      this.processes.forEach(oficio => {

        if(oficio.id==20 || oficio.id==25 || oficio.id==35 || oficio.id==42){
          $selectOficio.append(new Option(oficio.name, oficio.id));
        }
        
      });

      // Inicializar Select2
      $selectOficio.select2({
        placeholder: 'Seleccione un oficio',
        allowClear: true,
      }).on('change', () => {
        this.production_user.oficio_id = $selectOficio.val(); // Usar la variable ya definida
        this.userSearch = '';
        this.showUserSearch = false;
        this.filterUsersByOficioAndCuadrilla();
      });

      // Si hay un valor pre-seleccionado en production_user.oficio_id
      if (this.production_user.oficio_id) {
        $selectOficio.val(this.production_user.oficio_id).trigger('change');
      }

    } catch (error) {
      console.error('Error al obtener oficios:', error);
    }
  },
   async getCuadrillas() {
      try {
        // Obtener las cuadrillas desde el store
        this.cuadrillas = await this.$store.dispatch('crews/getAll');

        // Obtener referencia al select
        const $selectCuadrilla = $(this.$refs.cuadrillaSelect);

        // Destruir la instancia previa de Select2 si existe
        if ($selectCuadrilla.data('select2')) {
          $selectCuadrilla.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectCuadrilla.empty().append('<option value="">Todas</option>');

        this.cuadrillas.forEach(cuadrilla => {
          $selectCuadrilla.append(new Option(cuadrilla.name, cuadrilla.id));
        });

        // Inicializar Select2
        $selectCuadrilla.select2({
          placeholder: 'Todas',
          allowClear: true,
        }).on('change', () => {
          this.production_user.cuadrilla = $selectCuadrilla.val(); // Usar la variable ya definida
          this.userSearch = '';
          this.showUserSearch = false;
          this.filterUsersByOficioAndCuadrilla();
        });

        // Si hay un valor pre-seleccionado en production_user.cuadrilla
        if (this.production_user.cuadrilla) {
          $selectCuadrilla.val(this.production_user.cuadrilla).trigger('change');
        }

      } catch (error) {
        console.error('Error al obtener cuadrillas:', error);
      }
    },

    async getUsers() {
      this.users = await this.$store.dispatch('users/getAll', 'all');
      this.filterUsersByOficioAndCuadrilla();
    },
    filterUsersByOficioAndCuadrilla() {
      const oficioId = this.production_user.oficio_id;
      const cuadrillaId = this.production_user.cuadrilla;

      if (!oficioId) {
        this.filteredUsers = [];
        return;
      }

      const oficioIdNum = Number(oficioId);
      const cuadrillaIdNum = cuadrillaId ? Number(cuadrillaId) : null;
      const oficioName = (this.processes || [])
        .find((o) => Number(o.id) === oficioIdNum)?.name
        ?.toString()
        .trim()
        .toLowerCase();

      const roleMap = {
        'administrador': '1',
        'supervisor': '2',
        'operario': '3',
      };
      const roleToMatch = oficioName ? roleMap[oficioName] : undefined;

      // Primer filtro: solo por oficio (todos los usuarios de ese oficio)
      let usersByOficio = this.users.filter((user) => {
        if (roleToMatch) {
          const userRole = user?.role?.toString?.() ?? '';
          return userRole === roleToMatch;
        }
        const processes = Array.isArray(user.processes) ? user.processes : JSON.parse(user.processes || "[]");
        return processes.map(Number).includes(oficioIdNum);
      });

      // Segundo filtro: por cuadrilla (opcional)
      if (cuadrillaIdNum != null && cuadrillaId !== '') {
        usersByOficio = usersByOficio.filter((user) => {
          const userCuadrilla = user?.cuadrilla === '' || user?.cuadrilla === null || user?.cuadrilla === undefined
            ? null
            : Number(user.cuadrilla);
          return userCuadrilla === cuadrillaIdNum;
        });
      }

      this.filteredUsers = usersByOficio;
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async getModels() {
      try {
        // Obtener los modelos desde el store
        this.models = await this.$store.dispatch('inventory/getAll');

        // Obtener referencia al select
        const $select = $(this.$refs.modelSelect);

        // Destruir la instancia previa de Select2 si existe
        if ($select.data('select2')) {
          $select.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $select.empty().append('<option value="">Seleccionar Producto</option>');

        this.models.forEach(model => {
          if (model.bodega_id === 102) {
            $select.append(new Option(model.name, model.id));
          }
        });

        // Inicializar Select2
        $select.select2({
          placeholder: 'Seleccione un Producto',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
        }).on('change', () => {
          this.form.model_id = $select.val(); // Usar la variable ya definida
        });

        // Si hay un valor pre-seleccionado en form.model_id
        if (this.form.model_id) {
          $select.val(this.form.model_id).trigger('change');
        }

      } catch (error) {
        console.error('Error al obtener modelos:', error);
      }
    },
    async getSizes() {
      let tallas = await this.$store.dispatch('sizes/getData', this.production_model.model_id);
      this.sizes = tallas.data;
    },

    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    editRegisterNovelty(params) {
      this.novelty = params;
      this.openModalNovelty();
    },
    async deleteRegisterNovelty(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionNovelty/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getNovelties();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.messaged || 'Error al eliminar el registro',
        });
      }
    },
    openModalNovelty() {
      const modalElement = document.getElementById('ModalNovelty');
      this.modalNovelty = new Modal(modalElement); // Guarda la instancia del modal
      this.modalNovelty.show(); // Muestra el modal
    },
    closeModalNovelty() {
      if (this.modalNovelty) {
        this.modalNovelty.hide(); // Cierra el modal
      }
    },
    async submitFormNovelty() {
      try {
        this.novelty.production_id = this.form.id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionNovelty/save", this.novelty);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.novelty.total = 0;
              this.novelty.observation = '';

              this.closeModalNovelty();
              this.getNovelties();

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    openModal(modulo) {

      this.getOficios();
       
      this.getCuadrillas();
      this.getUsers();

      // Reset filtros
      this.production_user.cuadrilla = '';
      this.production_user.oficio_id = 0;
      this.production_user.user_id = [];
      this.filteredUsers = [];
      this.userSearch = '';
      this.showUserSearch = false;

      this.production_user.modulo = modulo;
      // Asignar por defecto las unidades totales de extrusión/secado al usuario
      this.production_user.received_quantity = this.getDefaultReceivedQuantityForModule(modulo);
      const modalElement = document.getElementById('ModalUsers');
      this.ModalUsers = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalUsers.show(); // Muestra el modal
    },
    closeModal() {
      if (this.ModalUsers) {
        this.ModalUsers.hide(); // Cierra el modal
      }
    },
    openModalDrying() {
      //this.calculateTotalQuantity();
      const modalElement = document.getElementById('ModalDrying');

      // Guarda temporalmente el production_id actual
      const currentProductionId = this.drying?.production_id || 0;
      const warehouse_id = this.drying.warehouse_id;


      const todayDate = new Date();
      const today = todayDate.toISOString().split('T')[0];

      // Reinicia todos los campos excepto production_id
      this.drying = {
        id: 0,
        production_id: currentProductionId, // mantiene el valor
        oven_id: '',
        type: 0,
        quantity: 0,
        warehouse_id: warehouse_id,
        started_at: today,
        assigned_at: today,
        delivered_at: '',
        total_quantity: 0
      };

      $(this.$refs.modelSelectHorno).val(null).trigger('change');

      this.ModalDrying = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalDrying.show(); // Muestra el modal

      this.getBodegas();
    },
    closeModalDrying() {
      if (this.ModalDrying) {
        this.ModalDrying.hide(); // Cierra el modal
      }
    },

    openModalLostTimes() {
      const modalElement = document.getElementById('ModalLostTimes');
      this.ModalLostTimes = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalLostTimes.show(); // Muestra el modal
    },
    closeModalLostTimes() {
      if (this.ModalLostTimes) {
        this.ModalLostTimes.hide(); // Cierra el modal
      }
    },



    openModalModel() {
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement); // Guarda la instancia del modal
      this.modalModel.show(); // Muestra el modal
    },
    closeModalModel() {
      if (this.modalModel) {
        this.modalModel.hide(); // Cierra el modal
      }
    },
    openModalDefects() {
      const modalElement = document.getElementById('ModalDefects');
      this.modalDefects = new Modal(modalElement); // Guarda la instancia del modal
      this.modalDefects.show(); // Muestra el modal
    },
    closeModalDefects() {
      if (this.modalDefects) {
        this.modalDefects.hide(); // Cierra el modal
      }
    },
    async getProductionUsers() {
      await this.$store.dispatch('productionUsers/getData', this.form.id);
      this.data = this.$store.state.productionUsers.getData;
      this.selectedProductionUserIds = [];
    },
    nowAsDbDateTime() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    getSelectedAssignedUsers() {
      const rows = (this.data?.data || []).filter((v) => v.modulo === 1 || v.modulo === 2);
      const selectedSet = new Set((this.selectedProductionUserIds || []).map(Number));
      return rows.filter((r) => selectedSet.has(Number(r.id)));
    },
    async markSelectedReceived() {
      if (this.isProductionFinished) return;

      const selectedRows = this.getSelectedAssignedUsers();
      const eligible = selectedRows.filter((r) => r.received_date == null);

      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos un registro pendiente por iniciar.' });
        return;
      }

      const result = await Swal.fire({
        title: 'Marcar como recibido',
        text: `Se iniciará el trabajo para ${eligible.length} registro(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.received_date = fecha;
        await this.$store.dispatch("productionUsers/save", row);
      }

      await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como recibidos: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async markSelectedDelivered() {
      if (this.isProductionFinished) return;

      const selectedRows = this.getSelectedAssignedUsers();
      const eligible = selectedRows.filter((r) =>
        r.received_date != null &&
        (r.delivered_date == null || (r.delivered_quantity < r.received_quantity))
      );

      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos un registro en progreso para finalizar.' });
        return;
      }

      const result = await Swal.fire({
        title: 'Marcar como entregado',
        text: `Se finalizará el trabajo para ${eligible.length} registro(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.delivered_date = fecha;
        await this.$store.dispatch("productionUsers/save", row);
      }

      await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como entregados: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async markSelectedValidated() {
      if (this.isProductionFinished) return;

      const selectedRows = this.getSelectedAssignedUsers();
      const eligible = selectedRows.filter((r) =>
        r.received_date  != null &&   // tiene inicio
        r.delivered_date != null &&   // tiene término
        r.validated_date == null      // aún no validado
      );

      if (eligible.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin registros',
          text: 'Selecciona al menos un registro entregado (y sin validar) para validar.',
        });
        return;
      }

      const { value: formValues } = await Swal.fire({
        title: 'Validar jornada',
        html: `
          <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, aceptar!',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          return {
            obs: document.getElementById('swal-input-obs').value
          };
        }
      });
      if (!formValues) return;

      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.validated_date = fecha;
        row.observation = formValues.obs;
        row.finish = 1;
        await this.$store.dispatch("productionUsers/save", row);
      }

      await Swal.fire({ icon: 'success', title: 'Jornada validada', text: `Validados: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async getInsumos() {
      const data = await this.$store.dispatch('productionModels/getData', this.form.id);
      this.insumos = data.data;
    },
    async getAllInsumos() {
      this.insumosInventory = await this.$store.dispatch('inventory/getAll');
    },
    async save() {
      if (this.isProductionFinished) {
        return;
      }
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("production/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {


              this.form = response.data;
              this.production_user.production_id = response.data.id || 0;

              this.extrusion.production_id = this.form.id || 0;
              this.drying.production_id = this.form.id || 0;

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const payload = {
          ...this.production_user,
          received_quantity: Number(this.production_model?.quantity_to_produce || this.production_user.received_quantity || 0) || 0,
        };
        const response = await this.$store.dispatch("productionUsers/save", payload);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getProductionUsers();
              this.closeModal();

              this.production_user.production_models_id = 0;
              this.production_user.oficio_id = 0;
              this.production_user.user_id = [];
              this.production_user.received_quantity = 0;
              this.production_user.price = 0;
              this.production_user.delivered_quantity = 0;


              $(this.$refs.modelUserSelect).val(null).trigger('change');
              $(this.$refs.processesSelect).val(null).trigger('change');
              $(this.$refs.usersSelect).val(null).trigger('change');

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async submitFormModel() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionModels/save", this.production_model);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.production_model.model_id = 0;
              this.production_model.size_id = 0;
              this.production_model.quantity_to_produce = 0;
              this.production_model.price = 0;

              $(this.$refs.modelSelect).val(null).trigger('change');
              $(this.$refs.sizesSelect).val(null).trigger('change');


              this.getInsumos();
              this.closeModalModel();


            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionModels/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    truncateObservation(text, maxLength = 35) {
      if (text === null || text === undefined) return '(Sin detalle)';
      const s = String(text).trim();
      if (!s) return '(Sin detalle)';
      if (s.length <= maxLength) return s;
      return s.slice(0, maxLength) + '...';
    },
    viewObservation(observation) {
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',
        confirmButtonText: 'Aceptar'
      });
    },
    syncCostosAdicionalesHeight() {
      this.$nextTick(() => {
        const left = this.$refs.productionFormCard;
        if (left && this.$refs.costosAdicionalesCard) {
          this.costosAdicionalesHeight = left.offsetHeight;
        }
      });
    },
    async checkReceived(value) {
      try {
        const result = await Swal.fire({
          title: 'Recibir tarea',
          text: 'Se marcará la tarea como recibida con la cantidad asignada.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
        });

        if (!result.isConfirmed) {
          return;
        }

        const now = new Date();
        const pad = n => String(n).padStart(2, '0');
        const receivedDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

        // Solo se actualiza la fecha; la cantidad recibida queda igual que en la asignación
        const payload = {
          ...value,
          received_date: receivedDate,
        };

        const response = await this.$store.dispatch("productionUsers/save", payload);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire(
            'Tarea recibida!',
            'Fecha registrada correctamente.',
            'success'
          );

          this.getProductionUsers();
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },

    async checkDelivered(value) {
      try {
        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
            <label for="swal-input-cant-entregada" class="form-label">Cantidad entregada:</label>
            <input
              id="swal-input-cant-entregada"
              type="number"
              class="form-control"
              placeholder="Cantidad entregada"
              min="0"
            >

            <label for="swal-input-cant-defectuosa" class="form-label mt-2">Cantidad defectuosa:</label>
            <input
              id="swal-input-cant-defectuosa"
              type="number"
              class="form-control"
              placeholder="Cantidad defectuosa"
              min="0"
            >
          `,
          focusConfirm: false,
          preConfirm: () => {
            const cant = parseInt(document.getElementById('swal-input-cant-entregada').value, 10);
            const defectuosa = parseInt(document.getElementById('swal-input-cant-defectuosa').value, 10);

            if (isNaN(cant) || cant < 0 || isNaN(defectuosa) || defectuosa < 0) {
              Swal.showValidationMessage('Debe ingresar valores válidos para las cantidades.');
              return;
            }

            return { cant, defectuosa };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          const now = new Date();
          const pad = n => String(n).padStart(2, '0');
          const deliveredDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const payload = {
            ...value,
            delivered_date: deliveredDate,
            delivered_quantity: formValues.cant,
            rejected_quantity: formValues.defectuosa,
          };

          const response = await this.$store.dispatch("productionUsers/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea entregada!',
              'Los datos se han guardado correctamente.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },


    async checkDeliveredDrying(value) {

      try {
        const result = await Swal.fire({
          title: 'Marcar como entregado',
          text: 'Al realizar esta acción el material estara disponible para usar desde el modulo de horno.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.delivered_at = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionDrying/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Registro de secado entregado!',
              'El registro se ha guardado correctamente.',
              'success'
            );

            this.getDrying();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },




    async checkValidated(value) {

      try {

        const { value: formValues } = await Swal.fire({
          title: 'Validar jornada',
          html: `
          <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Validar jornada del trabajador</label>
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            return {
              obs: document.getElementById('swal-input-obs').value
            };
          }
        });

        if (formValues) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.validated_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          value.observation = formValues.obs;
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);

          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Jordada validada!',
              'Excelente trabajo.',
              'success'
            );
            this.getProductionUsers();
          } else {
            this.getProductionUsers();
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);


        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });



      }
    },

    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

  },
  async mounted() {
    const today = new Date().toISOString().slice(0, 10);
    this.form.delivery_date = today;
    this.drying.started_at = today;

    for (let i = 0; i < 5; i++) {
      const ref = this.$refs[`collapse${i}`]
      if (ref) {
        this.bsCollapse[i] = new Collapse(ref, { toggle: false })
        // Track open/close for conditional action buttons
        ref.addEventListener('shown.bs.collapse', () => { this.collapseOpen[i] = true })
        ref.addEventListener('hidden.bs.collapse', () => { this.collapseOpen[i] = false })
      }
    }

    this.getModels();

    this.getBodegas();

    await this.getCategory(); 
   
    this.getUsers(); 

      $(this.$refs.processesSelect).val(null).trigger('change');


      const dataEdit = this.route.params.data;

      try {
        // Si hay datos para editar, cargarlos
        if (dataEdit) {
          const params = JSON.parse(dataEdit);
          this.data = params;
          if (params && params.id) {

            //Formulario principal
            this.form.id = params.id || 0;
            this.form.model_id = params.model_id || '';
            this.form.consecutivo = params.consecutivo || '';
            this.form.consecutivo_extruccion = params.consecutivo_extruccion || '';
            this.form.consecutivo_secado = params.consecutivo_secado || '';
            this.form.description = params.description || '';
            this.form.delivery_date = params.delivery_date || '';
            this.form.status = params.status || 0;
            this.form.sync_secado = params.sync_secado != null ? Number(params.sync_secado) : 0;
            $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
            // Deshabilitar select2 si la producción está terminada
            if (this.form.status == 2) {
              $(this.$refs.modelSelect).prop('disabled', true);
            }

            this.getProductionUsers();

            this.getDrying();

            await this.getNovelties();

            this.production_user.production_id = params.id || 0;

            //cargar id a extrusion
            this.extrusion.production_id = params.id || 0;
            if (params.extrusion) {
              this.extrusion = {
                id: params.extrusion.id || 0,
                production_id: params.id || 0,
                machine: params.extrusion.machine || 0,
                setup_count: params.extrusion.setup_count || 0,
                nozzle_type: params.extrusion.nozzle_type || 0,
                scheduled_time: params.extrusion.scheduled_time || 0,
                lost_time: params.extrusion.lost_time || 0,
                lost_time_details: params.extrusion.lost_time_details || [],
                effective_time: params.extrusion.effective_time || 0,
                setup_number: params.extrusion.setup_number || 0,
                cut_count: params.extrusion.cut_count || 0,
                units_per_cut: params.extrusion.units_per_cut || 0,
                quantity: params.extrusion.quantity || 0,
                extrusion_quantity: params.extrusion.extrusion_quantity || 0,
                extruded_weight: params.extrusion.extruded_weight || 0,
                dry_weight: params.extrusion.dry_weight || 0,
                clay_consumption: params.extrusion.clay_consumption || 0,
                total_consumption: params.extrusion.total_consumption || 0,
              }
              this.limitExtrusionToTwoDecimals();

              // Asignar inputValue a cada categoría
              this.categories = this.categories.map(category => {
                const lostTimeDetail = this.extrusion.lost_time_details.find(detail => detail.id === category.id);
                return {
                  ...category,
                  inputValue: lostTimeDetail ? lostTimeDetail.value : 0 // Asigna el valor o 0 si no existe
                };
              });
            }

            this.drying.production_id = params.id || 0;

          }
        }

        // Cerrar el modal de carga
        Swal.close();
      } catch (error) {
        // Manejo de errores
        console.error("Error al cargar los datos:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al cargar los datos. Por favor, inténtalo nuevamente.',
        });
      }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();

    this.$nextTick(() => {
      this.syncCostosAdicionalesHeight();
      const el = this.$refs.productionFormCard;
      if (el && typeof ResizeObserver !== 'undefined') {
        this.costosAdicionalesResizeObserver = new ResizeObserver(() => this.syncCostosAdicionalesHeight());
        this.costosAdicionalesResizeObserver.observe(el);
      }
    });
    setTimeout(() => this.syncCostosAdicionalesHeight(), 400);
  },
  beforeMount() {

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    if (this.costosAdicionalesResizeObserver && this.$refs.productionFormCard) {
      this.costosAdicionalesResizeObserver.disconnect();
    }
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.title-accent {
  font-weight: 700;
  color: #1f2d5a;
}

.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

/* Títulos de modales: mismo color y línea amarilla que el resto de section-title */
.modal-header .section-title {
  font-weight: 800;
  color: #1f2d5a !important;
  letter-spacing: 0.6px;
}
.modal-header .section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

/* Fila CREAR PRODUCCION + COSTOS ADICIONALES: formulario altura natural, costos con scroll si sobra contenido */
.production-top-row {
  align-items: flex-start;
}
.production-form-card {
  height: auto;
}
.costos-adicionales-card {
  min-height: 0;
  flex-shrink: 0;
}
.costos-adicionales-card-body {
  min-height: 0;
  overflow-y: auto;
  flex: 1 1 0;
}

/* COSTOS ADICIONALES: sin scroll horizontal, detalle con ellipsis, columnas bien repartidas */
.costos-adicionales-table-wrap {
  overflow-x: hidden;
  min-width: 0;
}
.costos-adicionales-table-wrap .table-layout-fixed {
  table-layout: fixed;
  width: 100%;
}
.costos-adicionales-table-wrap .costos-adicionales-th-detalle {
  width: 45%;
  min-width: 0;
}
.costos-adicionales-table-wrap .costos-adicionales-th-total {
  width: 28%;
}
.costos-adicionales-table-wrap .costos-adicionales-th-opciones {
  width: 27%;
  min-width: 5.5rem;
  white-space: nowrap;
}
.costos-adicionales-card {
  min-width: 280px;
}
.costos-adicionales-detalle-cell {
  overflow: hidden;
  max-width: 0;
  vertical-align: middle !important;
}
.costos-adicionales-detalle-link {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

/* Make table header titles stand out (Detalle/Total/Opciones/etc) */
.production-create-page .table thead th {
  color: #1f2d5a !important;
  opacity: 1 !important;
  font-weight: 800 !important;
  letter-spacing: 0.6px;
  font-size: 0.72rem;
}

.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.custom-checkbox-wrapper-assigned {
  display: flex;
  align-items: center;
}

.assigned-users-card .custom-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.custom-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.custom-checkbox-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid #6c757d;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0;
}

.custom-checkbox-label i {
  font-size: 10px;
  color: transparent;
  transition: color 0.2s ease;
}

.custom-checkbox:checked + .custom-checkbox-label {
  background-color: #28a745;
  border-color: #28a745;
}

.custom-checkbox:checked + .custom-checkbox-label i {
  color: white;
}

.custom-checkbox:hover + .custom-checkbox-label {
  border-color: #28a745;
}

.custom-checkbox:disabled + .custom-checkbox-label {
  opacity: 0.5;
  cursor: not-allowed;
 }

.assigned-user-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
</style>
